export const categories = [
  {
    key: "cat.shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    image: "https://readdy.ai/api/search-image?query=Premium%20white%20and%20pastel%20sneakers%20pair%20on%20clean%20light%20gray%20studio%20background%20soft%20even%20lighting%20centered%20ecommerce%20product%20photography%20minimal%20aesthetic%20high%20detail&width=500&height=500&seq=cat-shoes-01&orientation=squarish",
  },
  {
    key: "cat.hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Pastel%20color%20hoodie%20sweatshirt%20folded%20neatly%20on%20clean%20light%20gray%20studio%20background%20soft%20lighting%20centered%20ecommerce%20product%20photography%20minimal%20aesthetic%20high%20detail&width=500&height=500&seq=cat-hoodies-01&orientation=squarish",
  },
  {
    key: "cat.tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Plain%20pastel%20cotton%20t-shirt%20neatly%20displayed%20on%20clean%20light%20gray%20studio%20background%20soft%20lighting%20centered%20ecommerce%20product%20photography%20minimal%20high%20detail&width=500&height=500&seq=cat-tshirts-01&orientation=squarish",
  },
  {
    key: "cat.jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-windy-line",
    image: "https://readdy.ai/api/search-image?query=Stylish%20casual%20jacket%20on%20wooden%20hanger%20against%20clean%20light%20gray%20studio%20background%20soft%20lighting%20centered%20ecommerce%20product%20photography%20minimal%20aesthetic%20high%20detail&width=500&height=500&seq=cat-jackets-01&orientation=squarish",
  },
  {
    key: "cat.pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-scissors-line",
    image: "https://readdy.ai/api/search-image?query=Folded%20denim%20jeans%20and%20casual%20pants%20stacked%20on%20clean%20light%20gray%20studio%20background%20soft%20even%20lighting%20centered%20ecommerce%20product%20photography%20minimal%20aesthetic&width=500&height=500&seq=cat-pants-01&orientation=squarish",
  },
  {
    key: "cat.headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-user-line",
    image: "https://readdy.ai/api/search-image?query=Trendy%20baseball%20cap%20and%20knit%20beanie%20on%20clean%20light%20gray%20studio%20background%20soft%20lighting%20centered%20ecommerce%20product%20photography%20minimal%20aesthetic%20high%20detail&width=500&height=500&seq=cat-headwear-01&orientation=squarish",
  },
  {
    key: "cat.sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    image: "https://readdy.ai/api/search-image?query=Matching%20casual%20clothing%20outfit%20set%20top%20and%20pants%20laid%20flat%20on%20clean%20light%20gray%20studio%20background%20soft%20lighting%20centered%20ecommerce%20product%20photography&width=500&height=500&seq=cat-sets-01&orientation=squarish",
  },
  {
    key: "cat.underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-shield-check-line",
    image: "https://readdy.ai/api/search-image?query=Neatly%20folded%20soft%20cotton%20underwear%20briefs%20on%20clean%20light%20gray%20studio%20background%20soft%20lighting%20centered%20ecommerce%20product%20photography%20minimal%20aesthetic&width=500&height=500&seq=cat-underwear-01&orientation=squarish",
  },
  {
    key: "cat.jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Colorful%20sports%20jersey%20shirt%20displayed%20on%20clean%20light%20gray%20studio%20background%20soft%20lighting%20centered%20ecommerce%20product%20photography%20minimal%20aesthetic%20high%20detail&width=500&height=500&seq=cat-jersey-01&orientation=squarish",
  },
  {
    key: "cat.accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-glasses-line",
    image: "https://readdy.ai/api/search-image?query=Minimal%20wristwatch%20and%20sunglasses%20accessories%20on%20clean%20light%20gray%20studio%20background%20soft%20lighting%20centered%20ecommerce%20product%20photography%20minimal%20aesthetic&width=500&height=500&seq=cat-accessories-01&orientation=squarish",
  },
  {
    key: "cat.bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-shopping-bag-line",
    image: "https://readdy.ai/api/search-image?query=Stylish%20backpack%20and%20handbag%20on%20clean%20light%20gray%20studio%20background%20soft%20lighting%20centered%20ecommerce%20product%20photography%20minimal%20aesthetic%20high%20detail&width=500&height=500&seq=cat-bags-01&orientation=squarish",
  },
  {
    key: "cat.belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-links-line",
    image: "https://readdy.ai/api/search-image?query=Leather%20belts%20coiled%20neatly%20on%20clean%20light%20gray%20studio%20background%20soft%20lighting%20centered%20ecommerce%20product%20photography%20minimal%20aesthetic%20high%20detail&width=500&height=500&seq=cat-belts-01&orientation=squarish",
  },
  {
    key: "cat.perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-vip-diamond-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20on%20clean%20light%20gray%20studio%20background%20soft%20lighting%20centered%20ecommerce%20product%20photography%20minimal%20aesthetic%20high%20detail&width=500&height=500&seq=cat-perfumes-01&orientation=squarish",
  },
  {
    key: "cat.other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    image: "https://readdy.ai/api/search-image?query=Assorted%20small%20fashion%20accessories%20and%20gadgets%20neatly%20arranged%20on%20clean%20light%20gray%20studio%20background%20soft%20lighting%20centered%20ecommerce%20product%20photography&width=500&height=500&seq=cat-other-01&orientation=squarish",
  },
];